import SiteHeader from "../components/SiteHeader";
import SiteFooter from "../components/SiteFooter";
import { Mail, Sparkles, Calendar, GraduationCap, Bot, Users } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";
import { BRAND } from "../lib/brand";

export default function AboutPage() {
  const { lang } = useI18n();
  return (
    <div className="min-h-screen bg-white text-charcoal" data-testid="about-page">
      <SiteHeader variant="light" />
      <main>
        <section className="max-w-5xl mx-auto px-6 md:px-10 py-16 md:py-24">
          <p className="text-[11px] uppercase tracking-[0.32em] text-emerald2 font-semibold mb-5">{lang === "en" ? "About" : "Giới thiệu"}</p>
          <h1 className="font-serif text-5xl md:text-6xl text-charcoal">{lang === "en" ? "About Nail Viet Club" : "Về Nail Viet Club"}</h1>
          <p className="mt-6 text-lg text-warmgray-700 max-w-3xl leading-relaxed">
            {lang === "en"
              ? "Nail Viet Club is the business community for Vietnamese nail professionals — bringing together salon owners, educators, vendors, and technology partners to grow the industry through events, education, AI guidance, and modern tools."
              : "Nail Viet Club là cộng đồng kinh doanh dành cho người làm nail Việt Nam — kết nối chủ tiệm, chuyên gia đào tạo, đối tác và công nghệ để cùng phát triển ngành thông qua sự kiện, giáo dục, AI và công cụ hiện đại."}
          </p>
          <p className="mt-4 text-warmgray-700">{lang === "en" ? BRAND.taglineEn : BRAND.taglineVi}</p>

          <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {[
              { Icon: Calendar, vi: "Sự kiện", en: "Events" },
              { Icon: GraduationCap, vi: "Đào tạo", en: "Education" },
              { Icon: Bot, vi: "Cố vấn AI", en: "AI Advisor" },
              { Icon: Users, vi: "Networking", en: "Networking" },
            ].map(({ Icon, vi, en }, i) => (
              <div key={i} className="bg-warmgray-50 border border-warmgray-200 rounded-3xl p-6">
                <div className="w-12 h-12 rounded-2xl bg-emerald2 text-white flex items-center justify-center"><Icon className="w-5 h-5" /></div>
                <div className="mt-3 font-medium text-charcoal">{lang === "en" ? en : vi}</div>
              </div>
            ))}
          </div>
        </section>

        <section className="bg-charcoal-900 dark-surface">
          <div className="max-w-5xl mx-auto px-6 md:px-10 py-16 md:py-24 text-white relative overflow-hidden">
            <div className="absolute inset-0 summit-gradient opacity-90" />
            <div className="relative">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-gold-500/40 bg-white/5">
                <Sparkles className="w-3.5 h-3.5 text-gold-500" />
                <span className="text-[10px] uppercase tracking-[0.28em] text-gold-300 font-semibold">{lang === "en" ? "Technology partner" : "Đối tác công nghệ"}</span>
              </div>
              <h2 className="mt-4 font-serif text-4xl">Powered by AsterPOS Corp</h2>
              <p className="mt-3 text-white/80 max-w-2xl">{lang === "en"
                ? "AsterPOS is a technology platform purpose-built for the Vietnamese nail industry — POS, payments, scheduling, marketing, AI Voice, AI Chat, and analytics. Nail Viet Club runs on AsterPOS."
                : "AsterPOS là nền tảng công nghệ chuyên cho ngành nail Việt — POS, thanh toán, lịch hẹn, marketing, AI Voice, AI Chat và phân tích. Nail Viet Club vận hành trên AsterPOS."}</p>
            </div>
          </div>
        </section>
      </main>
      <SiteFooter />
    </div>
  );
}
